import queryString from 'query-string';

function hasDeveloperSwitch()
{
    const parsedQueryString = queryString.parse(location.search);
    return parsedQueryString.developer !== undefined;
}

export default hasDeveloperSwitch;


// WEBPACK FOOTER //
// ./common/js/lib/hasDeveloperSwitch.js